<template>
  <div class="form__newsletter__wrapper">
    <input
      class="form__newsletter__input accent-color" v-bind:class="this.enteredClass"
      v-bind:placeholder="this.placeholder"
      type="email" name="email" id="email" autocorrect="off" autocapitalize="off"
      spellcheck="false"
      v-on:focus="$emit('onEmailFocus', $event.target.value)"
      v-on:blur="$emit('onEmailBlur', $event.target.value)"
      v-bind:value="this.value"
      v-on:input="$emit('input', $event.target.value)"
      ref="inputInComponent"
      required
    />
    <div class="form__newsletter__icon">
      <newsletterSvg v-if="this.inputIsEmpty" :useAccentColor=this.useAccentColor></newsletterSvg>
    </div>
    <submitButton v-if="!this.inputIsEmpty" :useAccentColor=this.useAccentColor></submitButton>
  </div>
</template>

<script>
import newsletterSvg from "./icon__envelope--20--tight.vue";
import submitButton from "./submit-button.vue";

export default{
  props: ["value", "placeholder", "useAccentColor", "hasFocus", "enteredClass", "inputIsEmpty"],
  components: {
    newsletterSvg,
    submitButton
  },
  beforeUpdate: function() {
    if (this.hasFocus) {
      this.$refs.inputInComponent.focus()
    }
  }
}
</script>
